import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-gray p-2 mb-3"
}
const _hoisted_2 = { class: "subqueston-title" }
const _hoisted_3 = { class: "subqueston-title-left" }
const _hoisted_4 = {
  key: 2,
  class: "title"
}
const _hoisted_5 = { class: "subqueston-title-right" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 0,
  class: "title m-0 result-title result-success"
}
const _hoisted_8 = {
  key: 1,
  class: "title m-0 result-title result-failed"
}
const _hoisted_9 = {
  key: 2,
  class: "title m-0 result-title result-not-full"
}
const _hoisted_10 = { class: "p-2 mb-4" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "bg-white p-2 mb-4" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "explain-title m-0 ps-1 text-secondary d-flex py-1 align-center" }
const _hoisted_17 = { class: "text-gray ms-1 text-caption" }
const _hoisted_18 = { class: "ps-2" }
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]

import { onMounted } from 'vue'
import QuestionRadio from './QuestionRadio.vue'
import QuestionCheckBox from './QuestionCheckBox.vue'
import QuestionSelect from './QuestionSelect.vue'
import { useExamResultQuestionBody } from './useExamResultQuestionBody'
import Question from '../../models/question'
import Exam from '../../models/exam'
import UserExam from '../../models/user_exam'
import SchoolSetting from '../../../api/v2/models/school_setting'
import { ExamQScoreHistory } from '../../../api/v2/models/q_score_history'

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'ExamResultQuestionBodyMobile',
  props: {
    groupIndex: {},
    currentQuestion: {},
    index: {},
    schoolSetting: {},
    exam: {},
    userExam: {},
    isMultipleQuestion: { type: Boolean, default: false },
    examQScoreHistory: { default: null }
  },
  setup(__props: any) {

const props = __props

// Use composable
const {
  show,
  LETTER_FORMAT,
  markdownParser,
  qScoreHistorySummary,
  userScore,
  maxScore,
  score,
  isPass,
  isNotFullScore,
  isNotPass,
  explanation,
  value,
  content,
  dateFormat,
  getRateScore,
  getNameByExamType,
  skillItemsName,
  getSkillsName,
  initShow
} = useExamResultQuestionBody(props)

// Lifecycle
onMounted(() => {
  window.scrollTo(0, 0)
  initShow()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.currentQuestion && __props.currentQuestion.test && !__props.exam.autoDiagnosisEnabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (__props.currentQuestion.isTestQuestion)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(isPass))
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "blue"
                        }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-check", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    (_unref(isNotFullScore))
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          color: "green"
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-triangle-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    (_unref(isNotPass))
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 2,
                          color: "red"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("mdi-close", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    color: "blue"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-check", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })),
              (__props.isMultipleQuestion)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.groupIndex) + " - " + _toDisplayString(__props.index), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(Math.ceil((_unref(score) * 100) / __props.currentQuestion.maxScore)) + "%", 1 /* TEXT */)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (__props.currentQuestion.isWorkSheet)
      ? (_openBlock(), _createBlock(_component_v_chip, {
          key: 1,
          class: "m-2",
          color: "orange",
          "text-color": "white"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('question.work_sheet')) + " ", 1 /* TEXT */),
            _createVNode(_component_v_icon, { end: "" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-star", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (!__props.exam.autoDiagnosisEnabled && __props.currentQuestion.isTestQuestion && !__props.userExam.finishedAt)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_unref(userScore) == _unref(maxScore))
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                _createVNode(_component_v_icon, { color: "rgb(4, 4, 241)" }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode("mdi-circle-outline", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createTextVNode("正解です (" + _toDisplayString(_unref(maxScore)) + "点)", 1 /* TEXT */)
              ]))
            : (_unref(userScore) == 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                  _createVNode(_component_v_icon, { color: "rgb(223, 12, 12)" }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("mdi-close", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _cache[7] || (_cache[7] = _createTextVNode("不正解です (0点)", -1 /* CACHED */))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_9, [
                  _createVNode(_component_v_icon, { color: "rgb(1, 156, 1)" }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-triangle-outline", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }),
                  _createTextVNode(_toDisplayString(_unref(getRateScore)(_unref(userScore), _unref(maxScore))) + "% 正解です (" + _toDisplayString(_unref(userScore)) + "/" + _toDisplayString(_unref(maxScore)) + "点)", 1 /* TEXT */)
                ]))
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_10, [
      (_unref(show))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "question-body-preview-client subheading",
            innerHTML: _unref(content)
          }, null, 8 /* PROPS */, _hoisted_11))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", null, [
      (__props.currentQuestion.isTextarea)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", {
              readonly: "",
              class: "textarea-preview mt-0 p-3 mb-1",
              innerHTML: _unref(markdownParser)(_unref(value).length ? _unref(value)[0] : '')
            }, null, 8 /* PROPS */, _hoisted_13)
          ]))
        : (__props.currentQuestion.isCheckbox || __props.currentQuestion.isMultiCheckbox || __props.currentQuestion.isSelect)
          ? (_openBlock(), _createBlock(QuestionCheckBox, {
              key: 1,
              list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
              trueBgr: __props.exam.autoDiagnosisEnabled ? '#fff' : '#bce0fd',
              value: _unref(value) ? _unref(value) : [],
              readonly: ""
            }, null, 8 /* PROPS */, ["list", "trueBgr", "value"]))
          : (__props.currentQuestion.isRadio)
            ? (_openBlock(), _createBlock(QuestionRadio, {
                key: 2,
                list: __props.currentQuestion.answerItemsView ? __props.currentQuestion.answerItemsView : [],
                trueBgr: __props.exam.autoDiagnosisEnabled ? '#fff' : '#bce0fd',
                value: _unref(value).length ? _unref(value).find(x => !!x) : '',
                readonly: ""
              }, null, 8 /* PROPS */, ["list", "trueBgr", "value"]))
            : _createCommentVNode("v-if", true),
      (__props.currentQuestion.skills.length > 0 || _unref(explanation))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "explain-title p-2 text-secondary" }, "解説", -1 /* CACHED */)),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currentQuestion.skills, (skill, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "skill-text",
                  key: skill.name + index
                }, _toDisplayString(skill.name) + " > " + _toDisplayString(_unref(skillItemsName)(skill)), 1 /* TEXT */))
              }), 128 /* KEYED_FRAGMENT */)),
              _createElementVNode("div", {
                class: "exam-explain",
                innerHTML: _unref(explanation)
              }, null, 8 /* PROPS */, _hoisted_15)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_unref(qScoreHistorySummary) && __props.currentQuestion.isTestQuestion && _unref(qScoreHistorySummary).totalCount > 1 )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createElementVNode("div", _hoisted_16, [
              _createTextVNode(" 正解率 " + _toDisplayString(_unref(qScoreHistorySummary).rate) + "%(" + _toDisplayString(_unref(qScoreHistorySummary).successCount) + "/" + _toDisplayString(_unref(qScoreHistorySummary).totalCount) + ") ", 1 /* TEXT */),
              _createElementVNode("div", _hoisted_17, "いままで " + _toDisplayString(_unref(qScoreHistorySummary).totalCount) + "回やって" + _toDisplayString(_unref(qScoreHistorySummary).successCount) + "回正解しています", 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qScoreHistorySummary).histories, (history, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex",
                  key: index
                }, [
                  _createVNode(_component_v_col, { cols: "3" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(dateFormat)(history.createdAt)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "blue-text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(history.score > 0 ? '正解' : '不正解'), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */),
                  _createVNode(_component_v_col, { cols: "6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.examQScoreHistory?.examName) + " - " + _toDisplayString(_unref(getNameByExamType)(history.examType)), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (__props.currentQuestion.coursesWithLessons.length > 0 && __props.schoolSetting.useCourseLesson)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "explain-title p-2 text-secondary" }, "参考レッスン", -1 /* CACHED */)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.currentQuestion.coursesWithLessons, (courseWithLessons) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "bg-white p-2",
                key: courseWithLessons.course.id
              }, [
                _createVNode(_component_router_link, {
                  target: "_blank",
                  to: `/classroom/courses/${courseWithLessons.course.id}`
                }, {
                  default: _withCtx(({ href }) => [
                    _createElementVNode("a", {
                      href: href,
                      target: "_blank"
                    }, _toDisplayString(courseWithLessons.course.name), 9 /* TEXT, PROPS */, _hoisted_19)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseWithLessons.lessons, (lesson) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "lesson-margin",
                    key: lesson.id
                  }, [
                    _createVNode(_component_router_link, {
                      target: "_blank",
                      to: `/classroom/courses/${courseWithLessons.course.id}?lesson_id=${lesson.id}`
                    }, {
                      default: _withCtx(({ href }) => [
                        _createElementVNode("a", {
                          href: href,
                          target: "_blank"
                        }, _toDisplayString(lesson.name), 9 /* TEXT, PROPS */, _hoisted_20)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})